import React, { useEffect, useState } from 'react';
import CustomScroll from 'react-custom-scroll';
import { useIntl } from 'react-intl';
import { getDataPolicy } from 'src/services/api/company';
import makeCancelable from 'src/services/cancelablePromise';
import PrimaryButton from '../form-components/PrimaryButton/PrimaryButton';
import { IPopupable } from '../Popup/Popup';
import globalMessages from 'src/services/globalMessages';

const DataPolicy: React.FC<IPopupable> = ({ closePopup }) => {
    const intl = useIntl();
    const [adminPrivacyStatement, setAdminPrivacyStatement] = useState('');
    const [clientApprovalStatement, setClientApprovalStatement] = useState('');
    const fetchDataPolicy = (language: string) => {
        const dataPolicySubscription = makeCancelable(getDataPolicy(language));
        dataPolicySubscription.promise
            .then((dataPolicy) => {
                setAdminPrivacyStatement(dataPolicy.AdminPrivacyStatement);
                setClientApprovalStatement(dataPolicy.ClientApprovalStatement);
            })
            .catch(() => null);
        return dataPolicySubscription;
    };

    useEffect(() => {
        const dataPolicySubscription = fetchDataPolicy(intl.locale);

        return () => {
            dataPolicySubscription.cancel();
        };
    }, []);

    return (
        <section className="data-policy">
            <CustomScroll>
                <div className="data-policy__body">
                    <div dangerouslySetInnerHTML={{ __html: adminPrivacyStatement }} />
                    <div dangerouslySetInnerHTML={{ __html: clientApprovalStatement }} />
                </div>
            </CustomScroll>
            {closePopup && (
                <div className="data-policy__button">
                    <PrimaryButton
                        autoFocus={true}
                        onClick={closePopup}
                        caption={globalMessages.dataPolicyOk}
                    />
                </div>
            )}
        </section>
    );
};

export default DataPolicy;
